import { render } from "./UserData.vue?vue&type=template&id=0c8687e0&scoped=true"
import script from "./UserData.vue?vue&type=script&setup=true&lang=js"
export * from "./UserData.vue?vue&type=script&setup=true&lang=js"

import "./UserData.vue?vue&type=style&index=0&id=0c8687e0&lang=scss&scoped=true"

import exportComponent from "/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0c8687e0"],['__file',"src/pages/users/UserData.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "0c8687e0"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('0c8687e0', __exports__)) {
    console.log('reload')
    api.reload('0c8687e0', __exports__)
  }
  
  module.hot.accept("./UserData.vue?vue&type=template&id=0c8687e0&scoped=true", () => {
    console.log('re-render')
    api.rerender('0c8687e0', render)
  })

}


export default __exports__